"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrueViewDetailComponent = void 0;
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-explicit-any */
var tsyringe_1 = require("tsyringe");
var trueview_detail_service_1 = require("./trueview-detail.service");
var rxjs_1 = require("rxjs");
var trueview_7_0_service_1 = require("../TrueViewPage/trueview_7_0.service");
var TrueViewDetailComponent = /** @class */ (function () {
    function TrueViewDetailComponent(_trueViewDetailService, _trueViewService) {
        var _this_1 = this;
        this._trueViewDetailService = _trueViewDetailService;
        this._trueViewService = _trueViewService;
        this.intiData = function () {
            $(function () {
                if (window.location.href.includes('/true-view')) {
                    $('a[data-mnu-id="mnu-trueview"]').addClass('current');
                }
                $('li[data-mnu-id="mnu-products"]').hasClass('current') && $('li[data-mnu-id="mnu-products"]').removeClass('current');
                $('li[data-mnu-id="mnu-manufacturers"]').hasClass('current') && $('li[data-mnu-id="mnu-manufacturers"]').removeClass('current');
                _this_1.initSwiperProductEvent();
                _this_1.initSwiperTopTredingEvent();
                _this_1.initVideoListItemEvent();
                _this_1.initMediaPlayer();
                _this_1.initPaginationInfo();
                _this_1.setupLoadMoreListener();
                _this_1.initDrawerEvent();
                _this_1.initFollowManufactureEvent();
                _this_1.initLikeTrueViewEvent();
                _this_1.initShareTrueViewEvent();
                _this_1.initTotalClickEvent();
            });
        };
        this.initTotalClickEvent = function () {
            var _this = _this_1;
            $(".video-list .company-info .company-logo, \n        .video-list .company-info .company-name,\n        .video-list .company-info .action .view-profile").on('click', function () { _this.increateTotalClick(); });
        };
        this.increateTotalClick = function (trueViewId) {
            if (trueViewId === void 0) { trueViewId = ''; }
            var currentTrueViewId = trueViewId || $('#trueViewId').val().toString();
            currentTrueViewId && _this_1._trueViewService.PostIncreaseTotalClick(currentTrueViewId, baseTrueViewUrl);
        };
        this.initShareTrueViewEvent = function () {
            var _this = _this_1;
            TrueViewDetailComponent_1.IsCurrentTrueViewShared = false;
            $('#modalShareTrueView #copyButton').on('click', function () {
                return __awaiter(this, void 0, void 0, function () {
                    var copyText, error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                copyText = $(this).parent().find('#copyTrueView').get(0);
                                copyText.select();
                                document.execCommand("copy");
                                if (!!TrueViewDetailComponent_1.IsCurrentTrueViewShared) return [3 /*break*/, 4];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                TrueViewDetailComponent_1.IsCurrentTrueViewShared = true;
                                return [4 /*yield*/, _this._trueViewDetailService.IncreaseTotalShareTrueViewAsync($('#trueViewId').val().toString())];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _a.sent();
                                showAlertMessage(error_1.message);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            });
            $('.trueview-detail-container .share').on('click', function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        $("#modalShareTrueView").modal('show');
                        return [2 /*return*/];
                    });
                });
            });
        };
        this.initLikeTrueViewEvent = function () {
            var _this = _this_1;
            $('.trueview-detail-container .like').on('click', function () {
                return __awaiter(this, void 0, void 0, function () {
                    var isLiked, trueViewId, payload, rs, error_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                if (globalActionObj.handleSigninByPopup()) {
                                    return [2 /*return*/];
                                }
                                isLiked = $(this).hasClass('liked');
                                trueViewId = $('#trueViewId').val().toString();
                                payload = { trueViewId: trueViewId, isLike: !isLiked };
                                return [4 /*yield*/, _this._trueViewDetailService.LikeTrueViewAsync(payload)];
                            case 1:
                                rs = _a.sent();
                                if (rs.isSuccess) {
                                    $(this).toggleClass('liked');
                                    $(this).parent().find('.like-count').text(rs.result);
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                error_2 = _a.sent();
                                showAlertMessage(error_2.message);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            });
        };
        this.initFollowManufactureEvent = function () {
            var _this = _this_1;
            var trueViewSourceType = 1;
            $('.trueview-detail-container .follow').on('click', function () {
                return __awaiter(this, void 0, void 0, function () {
                    var isFollowing, manufactureId, payload, rs, error_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _this.increateTotalClick();
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                if (globalActionObj.handleSigninByPopup()) {
                                    return [2 /*return*/];
                                }
                                isFollowing = $(this).hasClass('following');
                                manufactureId = $('#manufactureId').val().toString();
                                payload = { manufactureId: manufactureId, isFavorite: !isFollowing, sourceType: trueViewSourceType };
                                $(this).toggleClass('following');
                                return [4 /*yield*/, _this._trueViewDetailService.FollowManufactureAsync(payload)];
                            case 2:
                                rs = _a.sent();
                                if (!rs.isSuccess) {
                                    $(this).toggleClass('following');
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                error_3 = _a.sent();
                                showAlertMessage(error_3.message);
                                $(this).toggleClass('following');
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            });
        };
        this.initDrawerEvent = function () {
            var drawerTriggerBtns = $('.view-product-btn, .view-more-btn');
            var drawers = $('.video-drawer');
            drawerTriggerBtns.on('click', function () {
                var target = $(this).data('target');
                $(".".concat(target)).addClass('active');
            });
            drawers.find('.close-drawer').on('click', function () {
                drawers.removeClass('active');
            });
        };
        this.initSwiperProductEvent = function () {
            var _this = _this_1;
            // swiper
            var slidesPerView = $(".related-product-swipeable .related-product-card").length > 3 ? 3.5 : 3;
            new Swiper(".related-product-swipeable", {
                slidesPerView: slidesPerView,
                spaceBetween: 12,
                navigation: {
                    nextEl: ".related-product-swipeable .swiper-button-next",
                    prevEl: ".related-product-swipeable .swiper-button-prev",
                },
            });
            $(".related-product-swipeable .related-product-card .card-thumbnail a,\n            .related-product-swipeable .related-product-card .product-name a").on('click', function () {
                _this.increateTotalClick();
            });
        };
        this.initSwiperTopTredingEvent = function () {
            var _this = _this_1;
            // swiper
            var slidesPerView = 3;
            new Swiper(".top-treding-swipeable", {
                slidesPerView: slidesPerView,
                spaceBetween: 8,
                navigation: {
                    nextEl: ".top-treding-swipeable .swiper-button-next",
                    prevEl: ".top-treding-swipeable .swiper-button-prev",
                },
            });
            $('.top-treding-swipeable .trending-item-wrapper').on('click', function () {
                var trueViewId = $(this).data('id');
                _this.increateTotalClick(trueViewId);
            });
        };
        this.initVideoListItemEvent = function () {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var _this = _this_1;
            $('.video-list-item').on('click', function () {
                var trueViewId = $(this).data('trueview-id');
                _this.increateTotalClick(trueViewId);
                _this.getTrueViewInfo(trueViewId);
                if (!$(this).hasClass('active')) {
                    $('.video-list-item').removeClass('active');
                    $(this).addClass('active');
                }
            });
        };
        this.initPaginationInfo = function () {
            // init pagination info
            _this_1.paginationInfo = {
                pageCount: _this_1.getValFromHiddenInput('#pageCount'),
                currentPage: _this_1.getValFromHiddenInput('#currentPage'),
                pageSize: _this_1.getValFromHiddenInput('#pageSize'),
                manufactureId: $('#manufactureId').val().toString(),
                langCode: null,
                trueViewId: $('#trueViewId').val().toString()
            };
        };
        this.initMediaPlayer = function () {
            _this_1.video = $('#TrueViewPlayer').get(0);
            _this_1.initializeUI();
            _this_1.attachEventListeners();
        };
        this.initializeUI = function () {
            _this_1.playPauseButton = $(".control-bar .play-button");
            _this_1.totalTimeDisplay = $('.total-time');
            _this_1.currentTimeDisplay = $('.current-time');
            _this_1.progressSeekBarInner = $('.progress-seek-bar .progress-inner');
            _this_1.progressSeekBar = $('.progress-seek-bar');
            _this_1.reachedBar = $('.progress-seek-bar .reached');
            _this_1.indicator = $('.progress-seek-bar .indicator');
            _this_1.volumeBar = $('.volume-bar .progress-inner');
            _this_1.volumeIndicator = $('.volume-bar .indicator');
            _this_1.volumeReachedBar = $('.volume-bar .reached');
            _this_1.fullscreenButton = $('.fullscreen-button');
            _this_1.centralControl = $('.center-control');
            _this_1.mutedBtn = $('.volume-button');
            _this_1.videoWrapper = $('.main-video-wrapper').get(0);
            // Initialize video muted
            _this_1.video.muted = true;
            _this_1.video.play();
            // 
            _this_1.volumeIndicator.css('left', _this_1.volumeIndicator.position().left - _this_1.volumeIndicator.width());
            // Initial UI setup
            _this_1.updateTotalTime();
            _this_1.setupDraggableControls();
        };
        this.attachEventListeners = function () {
            _this_1.playPauseButton.on('click', function () { return _this_1.togglePlayPause(); });
            _this_1.video.addEventListener('timeupdate', function () { return _this_1.updateProgressBar(); });
            _this_1.video.addEventListener('play', function () { return _this_1.updatePlayPauseIcons(); });
            _this_1.video.addEventListener('pause', function () { return _this_1.updatePlayPauseIcons(); });
            _this_1.video.addEventListener('ended', function () { return _this_1.onVideoEnded(); });
            _this_1.progressSeekBar.on('click', function (e) { return _this_1.seekVideo(e); });
            _this_1.volumeBar.on('click', function (e) { return _this_1.setVolume(e); });
            _this_1.fullscreenButton.on('click', function () { return _this_1.toggleFullScreen(); });
            _this_1.centralControl.on('click', function () { return _this_1.togglePlayPause(); });
            _this_1.mutedBtn.on('click', function () { return _this_1.toggleMuted(); });
        };
        this.updateTotalTime = function () {
            if (_this_1.video.readyState >= 1) {
                _this_1.totalTimeDisplay.text(_this_1.formatTime(_this_1.video.duration));
            }
            else {
                _this_1.video.addEventListener('loadedmetadata', function () {
                    _this_1.video.play();
                    _this_1.totalTimeDisplay.text(_this_1.formatTime(_this_1.video.duration));
                });
            }
        };
        this.setupDraggableControls = function () {
            _this_1.indicator.draggable({
                axis: 'x',
                containment: 'parent',
                drag: function (event, ui) {
                    var maxPos = _this_1.progressSeekBarInner.width() - _this_1.indicator.width();
                    var newPos = Math.min(ui.position.left, maxPos);
                    var newTime = (newPos / maxPos) * _this_1.video.duration;
                    _this_1.video.currentTime = newTime;
                    _this_1.updateProgressBar();
                }
            });
            _this_1.volumeIndicator.draggable({
                axis: 'x',
                containment: 'parent',
                drag: function (event, ui) {
                    var maxPos = _this_1.volumeBar.width() - _this_1.volumeIndicator.width();
                    var curPos = Math.min(ui.position.left, maxPos);
                    var curVol = (curPos / maxPos);
                    _this_1.video.volume = curVol;
                    _this_1.updateVolumeBar();
                }
            });
        };
        this.togglePlayPause = function () {
            if (_this_1.video.paused) {
                _this_1.video.play();
            }
            else {
                _this_1.video.pause();
            }
        };
        this.updatePlayPauseIcons = function () {
            var icon = 'isax-play5';
            if (_this_1.video.paused) {
                _this_1.centralControl.removeClass('playing');
            }
            else {
                _this_1.centralControl.addClass('playing');
                icon = 'isax-pause5';
            }
            _this_1.playPauseButton.find('i').attr('class', "isax ".concat(icon));
        };
        this.onVideoEnded = function () {
            _this_1.playPauseButton.find('i').attr('class', 'isax isax-play5');
            _this_1.centralControl.removeClass('playing');
        };
        this.seekVideo = function (e) {
            var maxPos = _this_1.progressSeekBarInner.width();
            var newPos = e.pageX - _this_1.progressSeekBarInner.offset().left;
            var newTime = (newPos / maxPos) * _this_1.video.duration;
            _this_1.video.currentTime = newTime;
        };
        this.setVolume = function (e) {
            var maxPos = _this_1.volumeBar.width();
            var newPos = e.pageX - _this_1.volumeBar.offset().left;
            var newVolume = newPos / maxPos;
            var percent = newVolume * 100;
            _this_1.video.volume = newVolume;
            _this_1.volumeIndicator.css('left', "".concat(percent, "%"));
            if (_this_1.volumeIndicator.position().left > _this_1.volumeBar.width() - _this_1.volumeIndicator.width()) {
                _this_1.volumeIndicator.css('left', "".concat(_this_1.volumeBar.width() - _this_1.volumeIndicator.width(), "px"));
            }
            _this_1.updateVolumeBar();
        };
        this.toggleFullScreen = function () {
            var videoElement = document.getElementById('TrueViewPlayer');
            if (!document.fullscreenElement && videoElement) {
                if (videoElement.requestFullscreen) {
                    videoElement.requestFullscreen();
                }
                else if (videoElement.webkitEnterFullscreen) {
                    videoElement.webkitEnterFullscreen(); // Special case for iOS Safari
                }
                else if (videoElement.msRequestFullscreen) {
                    videoElement.msRequestFullscreen();
                }
            }
            else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
        };
        this.toggleMuted = function () {
            _this_1.video.muted = !_this_1.video.muted;
            _this_1.mutedBtn.find('i').toggleClass('isax-volume-high5 isax-volume-slash5');
        };
        this.updateProgressBar = function () {
            var percent = (_this_1.video.currentTime / _this_1.video.duration) * 100;
            _this_1.reachedBar.width("".concat(percent, "%"));
            _this_1.indicator.css('left', "".concat(percent, "%"));
            _this_1.currentTimeDisplay.text(_this_1.formatTime(_this_1.video.currentTime));
        };
        this.updateVolumeBar = function () {
            var percent = _this_1.video.volume * 100;
            _this_1.volumeReachedBar.width("".concat(percent, "%"));
        };
        this.formatTime = function (time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60);
            return "".concat(minutes.toString().padStart(2, '0'), ":").concat(seconds.toString().padStart(2, '0'));
        };
        this.setupLoadMoreListener = function () {
            var loadMoreDivs = $('.load-more-videos').toArray();
            var scrollOObservables = loadMoreDivs.map(function (scrollContainer) { return (0, rxjs_1.fromEvent)($(scrollContainer), 'scroll'); });
            var loadMoreObservable = rxjs_1.merge.apply(void 0, scrollOObservables).pipe((0, rxjs_1.map)(function (value) { return ({
                scrollTop: $(value.target).scrollTop(),
                clientHeight: $(value.target).innerHeight(),
                scrollHeight: value.target.scrollHeight
            }); }), (0, rxjs_1.filter)(function (_a) {
                var scrollTop = _a.scrollTop, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
                return (scrollTop + clientHeight >= scrollHeight - 5 && _this_1.paginationInfo.currentPage < _this_1.paginationInfo.pageCount);
            }), (0, rxjs_1.debounceTime)(300));
            loadMoreObservable.subscribe({
                next: function () { return __awaiter(_this_1, void 0, void 0, function () {
                    var rs;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.paginationInfo.currentPage++;
                                ajLoading(true);
                                return [4 /*yield*/, this._trueViewDetailService.LoadMoreVideoTrueViewAsync(this.paginationInfo)];
                            case 1:
                                rs = _a.sent();
                                ajLoading(false);
                                if (rs.isSuccess) {
                                    this.appendTrueViews(rs.result);
                                    this.initVideoListItemEvent();
                                }
                                else {
                                    showAlertMessage(rs.result);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }
            });
        };
        this.getTrueViewInfo = function (trueViewId) { return __awaiter(_this_1, void 0, void 0, function () {
            var currentTrueViewId, rs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentTrueViewId = $('#trueViewId').val().toString();
                        if (!(currentTrueViewId !== trueViewId)) return [3 /*break*/, 2];
                        ajLoading(true);
                        return [4 /*yield*/, this._trueViewDetailService.GetTrueViewInfoAsync(trueViewId)];
                    case 1:
                        rs = _a.sent();
                        ajLoading(false);
                        $('#TrueViewInfo').html(rs);
                        this.initMediaPlayer();
                        this.initSwiperProductEvent();
                        this.initDrawerEvent();
                        this.updateTotalViewUIToCurrentVideo(trueViewId);
                        this.initLikeTrueViewEvent();
                        this.initShareTrueViewEvent();
                        this.initFollowManufactureEvent();
                        window.scrollTo({ top: 0, behavior: 'instant' });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.getValFromHiddenInput = function (selector) {
            var value = $(selector).val();
            var num = Number(value);
            return isNaN(num) ? 0 : num;
        };
        this.updateTotalViewUIToCurrentVideo = function (trueViewId) {
            var updateView = $('#TrueViewInfo .twTotalView').val();
            var $currentVideo = $(".video-list-item[data-trueview-id=\"".concat(trueViewId, "\"]"));
            if ($currentVideo.length > 0) {
                $currentVideo.find('.video-list-item-desc span.video-views span').text(updateView);
            }
        };
        this.intiData();
    }
    TrueViewDetailComponent_1 = TrueViewDetailComponent;
    TrueViewDetailComponent.prototype.appendTrueViews = function (trueViews) {
        var $loadMoreDiv = $('.load-more-videos');
        var appendTrueViewTemplate = $('#videoListItemTemplate');
        var fragment = document.createDocumentFragment();
        var currentTrueViewId = $('#trueViewId').val().toString();
        trueViews.forEach(function (tw) {
            var $cloneTemplate = appendTrueViewTemplate.clone();
            $cloneTemplate.attr('data-trueview-id', tw.id);
            $cloneTemplate.find('.video-list-item-img img').attr('src', tw.thumbnailUrl).attr('alt', tw.name);
            $cloneTemplate.find('.video-list-item-img-duration').text(tw.duration);
            $cloneTemplate.find('.video-list-item-desc span.video-name').text(tw.name);
            $cloneTemplate.find('.video-list-item-desc span.video-views span').text(tw.totalView);
            $cloneTemplate.find('.video-list-item-desc span.video-create-date').text(tw.createDateString);
            $cloneTemplate.removeAttr('id').show().toggleClass('active', currentTrueViewId === tw.id);
            fragment.appendChild($cloneTemplate[0]);
        });
        $loadMoreDiv.append(fragment);
    };
    var TrueViewDetailComponent_1;
    TrueViewDetailComponent.DESKTOP_WIDTH = 1200;
    TrueViewDetailComponent.TABLET_WIDTH = 992;
    TrueViewDetailComponent.IsCurrentTrueViewShared = false;
    TrueViewDetailComponent = TrueViewDetailComponent_1 = __decorate([
        (0, tsyringe_1.singleton)(),
        __metadata("design:paramtypes", [trueview_detail_service_1.default, trueview_7_0_service_1.default])
    ], TrueViewDetailComponent);
    return TrueViewDetailComponent;
}());
exports.TrueViewDetailComponent = TrueViewDetailComponent;
